import {PickupPoint} from '@domain/model/Account/PickupPoint/PickupPoint';
import {PickupPointCommand} from '@domain/model/Account/PickupPoint/PickupPointCommand';
import {PickupPointRepository} from '@domain/model/Account/PickupPoint/PickupPointRepository';

const GetPickupPoints =
  (
    pickupPointRepository: PickupPointRepository,
  ): ((pickupPointCommand: PickupPointCommand) => Promise<PickupPoint[] | []>) =>
  (pickupPointCommand: PickupPointCommand): Promise<PickupPoint[] | []> => {
    return pickupPointRepository.getPickupPoints(pickupPointCommand);
  };

export {GetPickupPoints};
